import React from "react";
import {Text, View, StyleSheet , Image ,useWindowDimensions } from 'react-native';
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import Config from '../../Config';

import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from "axios";
import toast from "../Components/Toast";
// import RenderHtml from 'react-native-render-html';

const Splash = ({navigation})=>{

    // const source = {
//         html: `
//             <div style="background-color:  red ">
//               <ul style="background-color: white ;fontfamily:yk">
//         <li style="color: red">123</li>
//         <li style="font-family:yk">123</li>
//         <li style="font-family:'yk'">321</li>
//         <li>123</li>
//         <li>123</li>
//         <li>123</li>
// </ul>
// </div>
//         `
//     };




    // const { width } = useWindowDimensions();
    React.useEffect(() => {
        setTimeout(async ()=>{
            let res = await axios.get(`${Config.api}/splash`,{ 'headers': {  Authorization: 'Bearer 123'} });
            if(res.data.version > Config.version){
                navigation.reset({
                    index: 0,
                    routes: [{ name: "Update" }],
                });
                return false;
            }else{
                let token = await AsyncStorage.getItem('token');
                if(token){
                    navigation.reset({
                        index: 0,
                        routes: [{ name: "Home" }],
                    });
                }else{
                    navigation.reset({
                        index: 0,
                        routes: [{ name: "Login" }],
                    });
                }
            }
        },800)
    },[])
    return (
        <View style={styles.container}>
            <Image
                resizeMode={'stretch'}
                fadeDuration={999}
                style={{
                    width : RFValue(400),
                    height :RFValue(400),

                }}
                source={require('../../assets/splash-icon.png')}
            />

                {/*<View style={{width:'100%'}}>*/}
                {/*    <RenderHtml*/}
                {/*        style={{ width : '100%'}}*/}
                {/*        contentWidth={width}*/}
                {/*        source={source}*/}
                {/*        systemFonts={['yk']}*/}
                {/*        tagsStyles={{div : {fontFamily : 'yk'}}}*/}
                {/*    />*/}
                {/*</View>*/}

        </View>
    );
}

export default Splash;
const styles = StyleSheet.create({
    text : {
      fontFamily : 'ykb',
        color: 'green'
    },


    container: {
        flex: 1,
        backgroundColor : Config.maincolor,
        justifyContent: 'center',
        alignItems: 'center',
    }
})